<ng-container *ngIf="setupPasswordOperation$ | async"></ng-container>
<div class="modal-body" [formGroup]="passForm">
  <div class="panel-item password">
    <label class="panel-label">Пароль</label>
    <input formControlName="password" type="{{isShowPassword ? 'text' : 'password'}}" class="panel-input" placeholder="Введите пароль">
    <button class="btn-group-eye" (click)="isShowPassword = !isShowPassword">
      <i class="pi {{isShowPassword ? 'pi-eye' : 'pi-eye-slash'}}"></i>
    </button>
  </div>

  <div class="panel-item password">
    <label class="panel-label">Повторите пароль</label>
    <input formControlName="confirmPassword" type="{{isShowConfirmPassword ? 'text' : 'password'}}" class="panel-input" placeholder="Повторите пароль">
    <button class="btn-group-eye" (click)="isShowConfirmPassword = !isShowConfirmPassword">
      <i class="pi {{isShowConfirmPassword ? 'pi-eye' : 'pi-eye-slash'}}"></i>
    </button>
  </div>

  <app-button
  [buttonClass]="'big-purple-gradient'"
  [text]="'Изменить пароль'"
  [disabled]="passForm.invalid || (setupPasswordOperationInFly$ | async)"
  (buttonClick)="setPassword()"
  [styleInline]="{ 'height': '100%', 'width': '100%' }"
></app-button>
</div>
